import React from 'react';
import {Button, Spinner} from "@material-tailwind/react";
import {color, variant} from "../../services/types/types";

interface CustomButtonProps {
    variant?: variant;
    text: string;
    className?: string;
    color?: color;
    disabled?: boolean;
    loading?: boolean;
    textSize?: string;
    testId?: string;
    onClick: () => void;
    icon?: React.ReactNode;
}

const CustomButton = ({ text, className, color, disabled, variant, loading, textSize, onClick, testId, icon }: CustomButtonProps) => {

    return (
        <Button data-testid={testId} placeholder={text} className={`${className ? className : 'bg-primary'} styleInput py-0 min-h-[36px] min-w-max custom-button ring-white`} color={color} variant={variant} disabled={disabled} onClick={onClick}>
            <div className="flex items-center justify-center min-w-max gap-1">
                {icon}
                <span className={`text-button ${color === 'gray' ? 'text-black' : ''}`} style={{fontSize: textSize ? textSize : '13px'}}>{text}</span>
                {loading && <Spinner className="h-4 w-4 ml-2" color="blue" />}
            </div>
        </Button>
    );
};

export default CustomButton;
